import React, { useState } from 'react';
import {
  Dialog, Pane, Select, TextInputField, Text, toaster, Label, Button
} from 'evergreen-ui';
import api from '../../services/api';

const CreateInviteDialog = ({ isShown, onClose, projectId, userRole }) => {
  const [role, setRole] = useState('member');
  const [expiresInHours, setExpiresInHours] = useState('');
  const [maxUses, setMaxUses] = useState('');
  const [loading, setLoading] = useState(false);
  const [generatedUrl, setGeneratedUrl] = useState('');

  const handleCreate = async () => {
    setLoading(true);
    try {
      const payload = { role };
      if (expiresInHours) payload.expires_in_hours = parseInt(expiresInHours, 10);
      if (maxUses) payload.max_uses = parseInt(maxUses, 10);

      const res = await api.post(`/projects/${projectId}/invites`, payload);
      const url = `${window.location.origin}/invite/${res.data.token}`;
      setGeneratedUrl(url);
      toaster.success('Invite link created');
    } catch (err) {
      toaster.danger(err.response?.data?.detail || 'Failed to create invite');
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(generatedUrl);
    toaster.success('Copied to clipboard');
  };

  const handleClose = () => {
    setGeneratedUrl('');
    setRole('member');
    setExpiresInHours('');
    setMaxUses('');
    onClose();
  };

  return (
    <Dialog
      isShown={isShown}
      title="Create Invite Link"
      onCloseComplete={handleClose}
      hasFooter={!generatedUrl}
      confirmLabel="Create"
      isConfirmLoading={loading}
      onConfirm={handleCreate}
    >
      {generatedUrl ? (
        <Pane>
          <Text display="block" marginBottom={8}>Share this link to invite someone:</Text>
          <Pane display="flex" alignItems="center" gap={8}>
            <TextInputField
              label=""
              value={generatedUrl}
              readOnly
              width="100%"
              fontFamily="mono"
              fontSize={12}
              marginBottom={0}
            />
            <Button onClick={handleCopy} flexShrink={0}>Copy</Button>
          </Pane>
          <Button marginTop={16} onClick={handleClose} width="100%">Done</Button>
        </Pane>
      ) : (
        <Pane>
          <Pane marginBottom={16}>
            <Label htmlFor="invite-role" display="block" marginBottom={4}>Role</Label>
            <Select
              id="invite-role"
              value={role}
              onChange={e => setRole(e.target.value)}
              width="100%"
            >
              <option value="viewer">Viewer (read-only)</option>
              <option value="member">Member (read/write)</option>
              {userRole === 'owner' && (
                <option value="admin">Admin (manage members)</option>
              )}
            </Select>
          </Pane>

          <TextInputField
            label="Expires in (hours)"
            placeholder="Leave empty for no expiration"
            type="number"
            min={1}
            value={expiresInHours}
            onChange={e => setExpiresInHours(e.target.value)}
          />

          <TextInputField
            label="Max uses"
            placeholder="Leave empty for unlimited"
            type="number"
            min={1}
            value={maxUses}
            onChange={e => setMaxUses(e.target.value)}
          />
        </Pane>
      )}
    </Dialog>
  );
};

export default CreateInviteDialog;
